import { useState } from 'react';

import { Box, Typography } from '@mui/material';

import { registerGuest } from '@/services/createZenotiPatient';

import DynamicForm, { DynamicFormProps } from './DynamicForm';

const containerStyles = {
	margin: '0 auto',
	width: 'clamp(300px, 98%, 650px)',
	'& .tag__dynamic-form__inputs > .tag__dynamic-form__input-row': {
		'& .tag__dynamic-form__message': {
			display: 'block',
			textAlign: 'center',
			'& .tag__dynamic-form__message-title': {
				fontSize: '1.75rem',
				lineHeight: '2.25rem',
			},
			'& .tag__dynamic-form__message-copy': {
				fontSize: '1.25rem',
			},
		},
		'& .tag__dynamic-form__field-error': {
			fontWeight: '200',
		},
	},
	'& .tag__dynamic-form__checkbox': {
		display: 'flex',
		alignSelf: 'flex-start',
	},
};

export default function ZenotiWrapper(props: Readonly<DynamicFormProps>) {
	const [submissionState, setSubmissionState] = useState('notasked');
	const [resultState, setResultState] = useState({
		centerId: '68abbc6b-26f4-45bd-95a2-9148f97ff105',
		lookup: 'notasked',
		signup: 'notasked',
		custom: 'notasked',
	});

	return (
		<Box id="zenoti-wrapper" sx={containerStyles}>
			{submissionState === 'notasked' && (
				<DynamicForm
					{...props}
					overrodeSubmitHandler={(formData) => {
						setSubmissionState('pending');

						registerGuest(formData)
							.then((result) => {
								setSubmissionState('success');
								setResultState(result);
								// redirect to zenoti
								setTimeout(() => {
									globalThis.location.href = `https://livportal.wellnow.com/webstoreNew/sales/membership/${result.centerId}`;
								}, 2000);

								return 'success';
							})
							.catch(() => {
								setSubmissionState('failure');
								console.error('Liv Registration call failed');
							});
					}}
				/>
			)}
			{submissionState === 'pending' && <Typography variant="header2">Submitting...</Typography>}
			{submissionState === 'success' && resultState.signup === 'success' && (
				<Typography variant="header2">Success! Thank you for signing up. Redirecting to finish...</Typography>
			)}
			{submissionState === 'success' && resultState.lookup === 'success' && (
				<Typography variant="header2">
					It looks like you are already registered. Please log in to access your account. Redirecting...
				</Typography>
			)}
			{submissionState === 'failure' && (
				<Typography variant="header2">
					Sorry - something went wrong. Please reload the page and try again.
				</Typography>
			)}
		</Box>
	);
}
